import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Website } from 'src/app/pages/teacher-page/models/interfaces/website';

@Component({
  selector: 'app-website-preview',
  templateUrl: './website-preview.component.html',
  styleUrls: ['./website-preview.component.css']
})
export class WebsitePreviewComponent implements OnChanges {
  @Input() website!: Website;
  fade: boolean = false;
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['website']) {
      this.triggerFade();
    }
  }
  triggerFade(): void {
    this.fade = false;
    setTimeout(() => {
      this.fade = true;
    }, 0);
  }
}
